import { useAuth } from 'contexts/AuthContext';

/**
 * 세션 기관코드(compCd) — JWT 기준.
 * DEMO 등 fallback 없이 세션 값만 반환한다.
 */
export function useTenantCode() {
  const { compCd } = useAuth();
  return String(compCd || '').trim();
}

/** 비훅 — 폼 default·콜백 등 */
export function resolveTenantCode(compCd) {
  return String(compCd || '').trim();
}

/**
 * 그리드·조회패널 prefs 키용 — 기관+사용자 격리
 */
export function buildPrefsUserId(tenantCode, user) {
  const tc = String(tenantCode || '').trim() || 'anon-tenant';
  const uid = user?.id || user?.userId || user?.username || 'anon';
  return `${tc}|${uid}`;
}

export default useTenantCode;
